import { ICONS } from 'constants/icons';
import { TEMPLATE } from 'constants/template';
import { useTranslation } from 'react-i18next';
import { InOut } from 'types/feature/parking.type';
import { findAgoFromNow } from 'utils/dateTime/ago';
import { formatTimestamp } from 'utils/dateTime/format';
import NoCarList from './NoCarList';
import styles from './ParkingCarList.module.scss';

type Props = {
  carList: InOut[];
};

export default function ParkingCarList({ carList }: Props) {
  const hasScroll = carList.length > 2;

  const { t } = useTranslation();

  return (
    <div className={styles.ParkingCarList}>
      {carList.length ? (
        <div className={styles.car_list}>
          <div className={styles.notice}>{t('parking.carList.description')}</div>

          <div className={styles.number_list}>
            <div className={`${styles.scroll_area} ${hasScroll && styles.has_scroll}`}>
              {carList.map(car => {
                return (
                  <div key={car.inId} className={styles.car_item}>
                    {/* 이미지 */}
                    <div className={styles.car_image_container}>
                      {car.inImageUri ? (
                        <img
                          src={car.inImageUri}
                          alt='car'
                          onError={e => {
                            const target = e.currentTarget;
                            target.onerror = null;
                            target.src = ICONS.CAR_DEFAULT;
                          }}
                        />
                      ) : (
                        <img src={ICONS.CAR_DEFAULT} alt='car' />
                      )}
                    </div>

                    {/* 정보 */}
                    <div className={styles.car_information}>
                      <div className={styles.full_number}>{car.plateNumber}</div>

                      <div className={styles.infos}>
                        <div className={styles.info_wrapper}>
                          <div className={styles.title}>{t('parking.carList.entryTime')}</div>
                          <div className={styles.value}>{formatTimestamp(car.inTime, TEMPLATE.PARKING)}</div>
                        </div>
                        <div className={styles.info_wrapper}>
                          <div className={styles.title}>{t('parking.carList.parkingDuration')}</div>
                          <div className={styles.value}>{findAgoFromNow(car.inTime)}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : (
        <NoCarList />
      )}
    </div>
  );
}
